<div class="external-link" [ngClass]="{ 'external-link--no-offset': !offsetTop }">
  <a draggable="false" [routerLink]="link" [target]="target">
    <svg-icon
      [src]="'/assets/img/ic-external-link.svg'"
      [svgStyle]="{ width: '16px', height: '16px' }"
    ></svg-icon>
  </a>
</div>
